import { isEmpty } from 'lodash'
import React, { useEffect, useState } from 'react'
import { Button } from '@/components/ui/button'
import { useDispatch, useSelector } from 'react-redux'
import { selectAccounts, selectFilters, selectSelectedAccounts } from './customers.selectors'
import { actions } from './customers.slice'
import { ACCOUNT_TYPE, CUSTOMER_MODALS } from './customers.constants'
import {
	fetchAccountDetails,
	fetchAccountUsers,
} from '../Account/account.asyncActions'
import { selectAccountUsers } from '../Account/account.selector'
import { selectIsAdmin } from '../Profile/profile.selectors'
import { USER_ROLES_ENUMS } from '../Account/account.constants'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { Input } from '@/components/ui/input'
import { Switch } from '../../components/ui/switch'
import {
	BILLING_STATUS_OPTIONS,
	getBillingStatusValue,
	shouldShowBillingStatusFilter,
	toBillingStatusFilters,
} from './customerDelinquency'

const { setSelectedCustomerModal, setCustomerFilters } = actions
const FIRST_PAGE = 1
const searchCustomerOptions = [
	{
		label: 'Search By Account Name',
		value: 'accountName',
		placeholder: 'Account Name',
	},
	{
		label: 'Search By User Name',
		value: 'userName',
		placeholder: 'User Name',
	},
	{
		label: 'Search By Email Address',
		value: 'userEmail',
		placeholder: 'User Email Address',
	},
	{
		label: 'Search By FFL Number',
		value: 'FflNumber',
		placeholder: 'FFL Number',
	},
]

const CustomersFilter = () => {
	const dispatch = useDispatch()
	const selectedAccounts = useSelector(selectSelectedAccounts)
	const accountUsers = useSelector(selectAccountUsers)
	const isAdmin = useSelector(selectIsAdmin)
	const customerFilters = useSelector(selectFilters)
	const customerAccounts = useSelector(selectAccounts)
	const selectedAccount = selectedAccounts[0]
	const [searchCriteria, setSearchCriteria] = useState(() => {
		const activeOption = searchCustomerOptions.find(
			(opt) => customerFilters[opt.value] != null && customerFilters[opt.value] !== ''
		)
		return activeOption || searchCustomerOptions[0]
	})
	const salesRepresentatives = accountUsers.filter(
		(each) => each.userRole === USER_ROLES_ENUMS.SALES
	)

	const isFFLNotExists = selectedAccounts.some((some) => some.isDuplicate)

	const isAnySingleFFLType = selectedAccounts.some(
		(each) => ACCOUNT_TYPE[each.type] === ACCOUNT_TYPE[0]
	)

	useEffect(() => {
		isAdmin && dispatch(fetchAccountUsers())
	}, [dispatch, isAdmin])

	function setSearchCriteriaAndClearFeild(srchOpt) {
		setSearchCriteria(srchOpt)
		dispatch(
			setCustomerFilters({
				accountName: null,
				userName: null,
				userEmail: null,
				FflNumber: null,
				page: FIRST_PAGE,
			})
		)
	}

	function HandleSetCustomerFilters(filterName, value) {
		const nextValue =
			typeof value !== 'boolean'
				? value
				: customerFilters[filterName] === value
					? null
					: value
		dispatch(
			setCustomerFilters({
				[filterName]: nextValue,
				page: FIRST_PAGE,
			})
		)
	}

	return (

			<div className='flex flex-row gap-2 items-center'>
				<div className='w-full'>
					<Select
						value={searchCriteria.value}
						onValueChange={(val) => {
							const found = searchCustomerOptions.find((o) => o.value === val)
							if (found) setSearchCriteriaAndClearFeild(found)
						}}
					>
						<SelectTrigger className='w-full'>
							<SelectValue placeholder={searchCriteria.label} />
						</SelectTrigger>
						<SelectContent>
							{searchCustomerOptions.map((srchOpt) => (
								<SelectItem key={srchOpt.value} value={srchOpt.value}>
									{srchOpt.label}
								</SelectItem>
							))}
						</SelectContent>
					</Select>
				</div>
				<div className='w-full'>
					<div className={'form-group'}>
						<Input
							className='search-input'
							placeholder={`${searchCriteria.placeholder}`}
							value={customerFilters[`${searchCriteria.value}`] ?? ''}
							onChange={(ev) =>
								HandleSetCustomerFilters(searchCriteria.value, ev.target.value)
							}
						/>
					</div>
				</div>
		
					{isAdmin && (
						<div className='w-full'>
							<Select
								value={customerFilters.sales ?? ''}
								onValueChange={(val) => HandleSetCustomerFilters('sales', val)}
							>
								<SelectTrigger className='w-full'>
									<SelectValue placeholder='All Sales Representatives' />
								</SelectTrigger>
								<SelectContent>
									{salesRepresentatives.map((each) => (
										<SelectItem key={each.id} value={each.id}>
											{each.name}
										</SelectItem>
									))}
								</SelectContent>
							</Select>
						</div>
					)}
					<div className='flex flex-row gap-2 items-center min-w-32'>
						<span className='text-xs text-muted-foreground'>Backup Tool Installed?</span>
						<Switch checked={customerFilters.backupToolInstalled} onCheckedChange={(_) => HandleSetCustomerFilters('backupToolInstalled', _)} />
					</div>
					<div className='flex flex-row gap-2 items-center min-w-32'>
						<span className='text-xs text-muted-foreground'>Backup Tool Downloaded?</span>
						<Switch checked={customerFilters.backupToolDownloadClicked} onCheckedChange={(_) => HandleSetCustomerFilters('backupToolDownloadClicked', _)} />
					</div>
					{shouldShowBillingStatusFilter(customerAccounts, customerFilters) && (
					<div className='min-w-52'>
						<Select
							value={getBillingStatusValue(customerFilters)}
							onValueChange={(val) =>
								dispatch(
									setCustomerFilters({
										...toBillingStatusFilters(val),
										page: FIRST_PAGE,
									})
								)
							}
						>
							<SelectTrigger className='w-full' aria-label='Billing status'>
								<SelectValue placeholder='All billing statuses' />
							</SelectTrigger>
							<SelectContent>
								{BILLING_STATUS_OPTIONS.map((option) => (
									<SelectItem key={option.value} value={option.value}>
										{option.label}
									</SelectItem>
								))}
							</SelectContent>
						</Select>
					</div>
					)}
					
		
                <div className='flex items-center gap-2 ml-auto'>
                    {isAdmin && !isEmpty(selectedAccounts) && (
                        <Button
                            className='f-14 account-section-button'
                            onClick={() =>
                                dispatch(
                                    setSelectedCustomerModal(CUSTOMER_MODALS.EDIT_ASSIGNMENT_MODAL)
                                )
                            }
                        >
                            Assign Account
                        </Button>
                    )}
                    {isAdmin && isAnySingleFFLType && (
                        <Button
                            className='f-14 ml-2 account-section-button'
                            onClick={() => {
                                dispatch(
                                    setSelectedCustomerModal(
                                        CUSTOMER_MODALS.SWITCH_ACCOUNT_TYPE_MODAL
                                    )
                                )
                                dispatch(fetchAccountDetails(selectedAccount.id))
                            }}
                            disabled={selectedAccounts.length > 1}
                            title={selectedAccounts.length > 1 ? 'Only one row can be selected' : undefined}
                        >
                            Switch Account Type
                        </Button>
                    )}
                    {isAdmin && isFFLNotExists && (
                        <Button
                            className='f-14 ml-2 account-section-button'
                            onClick={() =>
                                dispatch(
                                    setSelectedCustomerModal(
                                        CUSTOMER_MODALS.DELETE_DUPLICATE_ACCOUNT_MODAL
                                    )
                                )
                            }
                            disabled={selectedAccounts.length > 1}
                            title={selectedAccounts.length > 1 ? 'Only one row can be selected' : undefined}
                        >
                            Delete Account
                        </Button>
                    )}
                </div>
			</div>
	)
}

export default CustomersFilter
